<template>
  <div v-if="lance.deleted">
    <e-btn-circle-status status="negative" class="sm m-r-xs fa-fw" /><span class="text-negative">Deletado</span>
  </div>
  <div v-else-if="lance.status === Status.STATUS_VENCENDO">
    <e-btn-circle-status status="grey" class="sm m-r-xs fa-fw" /><span class="text-grey">Melhor oferta</span>
  </div>
  <div v-else-if="lance.status === Status.STATUS_SUPERADO">
    <e-btn-circle-status status="warning" class="sm m-r-xs fa-fw" /><span class="text-warning">Superado</span>
  </div>
  <div v-else-if="lance.status === Status.STATUS_VENCEDOR">
    <e-btn-circle-status status="positive" class="sm m-r-xs fa-fw" /><span class="text-positive">Vencedor</span>
  </div>
  <div v-else-if="lance.status === Status.STATUS_CANCELADO">
    <e-btn-circle-status status="negative" class="sm m-r-xs fa-fw" /><span class="text-negative">Cancelado</span>
  </div>
  <div v-else></div>
</template>

<script>
import {EBtnCircleStatus} from 'uloc-vue-plugin-erp'
import * as Status from '../../../../../domain/leiloes/helpers/LanceStatus'

export default {
  name: 'LanceRegistroStatus',
  props: ['lance'],
  computed: {
    Status () {
      return Status
    }
  },
  components: {EBtnCircleStatus}
}
</script>
